export default "__VITE_ASSET__ChBsASFW__"